import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';

@Component({
  selector: 'app-range-date-picker',
  templateUrl: './range-date-picker.component.html',
  styleUrls: ['./range-date-picker.component.sass'],
})
export class RangeDatePickerComponent implements OnInit {
  @Input()
  config: IFieldConfig;

  @Input()
  group: FormGroup;

  @Input()
  typeCes?: TypeCesEnum | undefined;

  constructor() {}

  ngOnInit(): void {}
}
